export default {
    'language': '丹麦',
}
;
